export const environment = {
  production: false,
  baseFixUrl: 'https://fixdigital-lms.win4.tempurl.info/',
  baseUrl: 'https://fixdigital-lms.win4.tempurl.info/api/crm/webapp/v1/',
  baseUrlV1: "https://fixdigital-lms.win4.tempurl.info/api/crm/webapp/v1/",
  baseUrlV2: "https://fixdigital-lms.win4.tempurl.info/api/crm/webapp/v2/",
  version: "2.4.67"
};
